/**
 * Navigate the user into the subscription upgrade flow.
 *
 * Extracted from `useAccess().upgradeTo` so it can be reused by lightweight
 * presentational components (e.g. `AppRestrictedState`, mini visualizations)
 * WITHOUT pulling the entitlements store / i18n module chain into their
 * bundle — this file only depends on the (store-free) subscription
 * return-path helper plus `window`.
 *
 * The user lands on the hash-router `/subscriptions` builder with enough
 * context to preselect/highlight the right upgrade path. Checkout itself is
 * always confirmed from the builder.
 *
 * @param {string|null} missingKey  Canonical entitlement key that was gated.
 * @param {{
 *   offer_type?: string,
 *   stripe_price_id?: string|null,
 *   self_serve?: boolean,
 *   name?: string|null,
 * }|null} [offer]  scrumble's resolved BillingOffer from the 403 detail.
 */
import { rememberSubscriptionReturnPath } from '@/utils/subscriptionCheckoutReturn';

export function goToUpgrade(missingKey = null, offer = null) {
  rememberSubscriptionReturnPath();

  const params = new URLSearchParams();
  if (missingKey) {
    params.set('upgrade', missingKey);
  }
  if (offer?.self_serve && offer?.stripe_price_id) {
    params.set('price', offer.stripe_price_id);
  }
  if (offer?.offer_type) {
    params.set('offer_type', offer.offer_type);
  }
  const query = params.toString();
  window.location.assign(`/#/subscriptions${query ? `?${query}` : ''}`);
}
